import { Grid, GridItem, useToken } from "@chakra-ui/react";
import { useContext } from "react";
import { useIntl } from "react-intl";
import { Marker } from "react-map-gl/maplibre";

import { ContentPanel } from "@/components/content-panel";
import { ImproveRanaOverviewBlock } from "@/components/improve-rana-overview-block";
import { EventsList } from "@/features/project-events";
import { EventsListModal } from "@/features/project-events";
import { useProjectBounds } from "@/hooks/use-project-bounds";
import { ProfileList } from "@/lib/profile";
import { RanaMap } from "@/lib/rana-map";
import { ProjectContext } from "@/stores/project-provider";

const PROJECT_GRID_ITEM_HEIGHT = "2xs";

export function ProjectOverview() {
  const project = useContext(ProjectContext);
  const intl = useIntl();
  const [keepAnalytic] = useToken("colors", ["brand.keep_analytic"]);
  const projectBounds = useProjectBounds();

  return (
    <Grid
      templateColumns={{
        base: "repeat(1, 100%)",
        md: "repeat(2, 1fr)",
        lg: "repeat(3, 1fr)",
      }}
      gap={4}
    >
      <GridItem height={PROJECT_GRID_ITEM_HEIGHT}>
        <ContentPanel
          title={intl.formatMessage({
            defaultMessage: "Description",
            id: "blocktitle.description",
          })}
        >
          {project.description ?? null}
        </ContentPanel>
      </GridItem>
      <GridItem height={PROJECT_GRID_ITEM_HEIGHT}>
        <ContentPanel
          title={
            intl.formatMessage({
              defaultMessage: "Contributors",
              id: "blocktitle.contributors",
            }) +
            " (" +
            project.contributors.length +
            ")"
          }
        >
          <ProfileList users={project.contributors} />
        </ContentPanel>
      </GridItem>
      <GridItem height={PROJECT_GRID_ITEM_HEIGHT}>
        <ContentPanel
          title={intl.formatMessage({
            defaultMessage: "Latest activity",
            id: "blocktitle.latest_activity",
          })}
          p={0}
          rightLink={<EventsListModal filterBy="project" />}
        >
          <EventsList filterBy="project" />
        </ContentPanel>
      </GridItem>

      {project.location && (
        <GridItem height={PROJECT_GRID_ITEM_HEIGHT}>
          <ContentPanel
            title={intl.formatMessage({
              defaultMessage: "Location",
              id: "blocktitle.location",
            })}
            p={0}
            overflow="hidden"
          >
            <RanaMap
              mapId="projectOverviewLocationMap"
              bounds={projectBounds}
              mapProps={{}}
              isSmallControls
            >
              {project.location && (
                <Marker
                  color={keepAnalytic}
                  longitude={project.location.coordinates[0]}
                  latitude={project.location.coordinates[1]}
                  anchor="center"
                />
              )}
            </RanaMap>
          </ContentPanel>
        </GridItem>
      )}

      <ImproveRanaOverviewBlock />
    </Grid>
  );
}
